import { ColoursObj, Icon } from '@eventr/common-storybook'
import { flatten } from 'lodash'
import { useCallback, useMemo } from 'react'
import { Marker } from 'react-map-gl/maplibre'
import { useShallow } from 'zustand/react/shallow'
import { useEphemeralStore } from '../../../../state/useEphemeralStore'
import { getIconName } from '../../../../v2/v2Utils'
import LocationDot from '../components/locationDot'
import { LngLatLabelledItineraryComponents } from '../interfaces/locationLabelledObject'

export default function ItineraryComponentMarkers({
    locations,
}: {
    locations: LngLatLabelledItineraryComponents[]
}) {
    const { selectLngLatLabelledItineraryComponents } = useEphemeralStore(
        useShallow((s) => {
            return {
                selectLngLatLabelledItineraryComponents:
                    s.selectLngLatLabelledItineraryComponents,
            }
        })
    )

    const onClick = (
        lngLatLabelledItineraryComponent: LngLatLabelledItineraryComponents
    ) => {
        selectLngLatLabelledItineraryComponents(
            lngLatLabelledItineraryComponent,
            lngLatLabelledItineraryComponent.lngLat
        )
    }

    const getIconKey = useCallback(
        (
            lngLatLabelledItineraryComponents: LngLatLabelledItineraryComponents
        ) => {
            const iconNames = [
                ...new Set(
                    flatten([
                        ...Object.values(
                            lngLatLabelledItineraryComponents.object.present
                        ),
                        ...Object.values(
                            lngLatLabelledItineraryComponents.object.past
                        ),
                    ]).map((component) =>
                        getIconName(Number(component.data['_id'].split('.')[1]))
                    )
                ),
            ]

            return iconNames.length > 1 ? 'List' : iconNames[0]
        },
        [locations]
    )

    const markers = useMemo(() => {
        return locations.map((lngLatLabelledItineraryComponent, index) => (
            <Marker
                key={index}
                longitude={lngLatLabelledItineraryComponent.lngLat.lng}
                latitude={lngLatLabelledItineraryComponent.lngLat.lat}
                onClick={() => onClick(lngLatLabelledItineraryComponent)}
            >
                <LocationDot
                    diameter={40}
                    backgroundColor={ColoursObj.backgrounds.secondary}
                >
                    <Icon
                        name={getIconKey(lngLatLabelledItineraryComponent)}
                        width="28px"
                        height="28px"
                        iconColour={ColoursObj.core.secondary}
                    ></Icon>
                </LocationDot>
            </Marker>
        ))
    }, [locations])

    return <>{markers}</>
}
